import axios, { AxiosError } from "axios";
import { attachAuthInterceptors } from "@cyngn/auth-react";

import { FMSLogger } from "FMSLogger";
import { sendTelemetryEvent } from "./faroUtils";
import { BASE } from "./api";
import "./authTokenStore";
import { redirectToLogin } from "./authRedirect";
import { applyObservabilityHeaders } from "./observabilityHeaders";

const networkLogger = FMSLogger.byPrefix("network-logs");

const instance = axios.create({
  baseURL: BASE,
});

// Bearer and refresh-and-retry come from the shared library, on the same session as the
// cloud-core client (DEV-5751).
attachAuthInterceptors(instance, {
  onAuthFailure: () => {
    redirectToLogin();
  },
});

instance.interceptors.response.use(
  (response) => {
    networkLogger.debug(
      "API response",
      response.config.url as string,
      response.data
    );
    return response;
  },
  async (error: AxiosError) => {
    networkLogger.error(
      "API error",
      error.message,
      error.code ?? "",
      error.config?.url ?? "",
      error.response?.data ?? ""
    );
    if (!axios.isCancel(error)) {
      sendTelemetryEvent(error, "API error");
    }
    throw error;
  }
);

instance.interceptors.request.use(function (config) {
  // The broker is not company-scoped, so only the correlation id is sent.
  applyObservabilityHeaders(config, { withActiveCompany: false });
  networkLogger.debug(
    "API request",
    config.url as string,
    config.method as string,
    config.data ?? ""
  );
  return config;
});

export default instance;
